import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import TrialPopup from './components/TrialPopup';
import ModernAlertHost from './components/ModernAlertHost';
import SessionIdleWatcher from './components/SessionIdleWatcher';
import SessionTimeoutModal from './components/SessionTimeoutModal';
import { TrialProvider } from './context/TrialContext';
import { UserProvider } from './context/UserContext';
import { applyThemeToDocument, getStoredTheme } from './utils/theme';
import { stripJwtFromStorage } from './utils/authSession';

import './assets/fonts/local-fonts.css';
import './index.css';

export default function BrandAdminFlowLayout() {
  useEffect(() => {
    stripJwtFromStorage();
    applyThemeToDocument(getStoredTheme());
  }, []);

  return (
    <UserProvider>
      <TrialProvider>
        <TrialPopup />
        <ModernAlertHost />
        <SessionIdleWatcher />
        <SessionTimeoutModal />
        <Outlet />
      </TrialProvider>
    </UserProvider>
  );
}
